// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"807a24a8","248":"5efc7f3b","319":"97626e71","364":"1bdd835d","471":"860e7802","499":"42d6ce22","566":"57dcdd04","583":"0b3f40f0","756":"130a058b","895":"cec5c01d","907":"a2dc7424","983":"f7f55dab"}[chunkId] + ".chunk.js";
};